import { gql } from '@apollo/client';

const GET_BASELINE_REPORT = gql`
  query GetBaselineReport {
    baselineReport {
      PracticeAreas {
        Name
        Acronym
        DefaultLevel
        IncludeHigherLevels
        IncludeHigherProgramYears
        AggregatePercentage {
          Name
          Results
          Cnt
        }
        Practices {
          Level
          NumberInLevel
          PracticeName
          Name
          Satisfied
          Partial
          Deficient
        }
      }
    }
  }
`;

export default GET_BASELINE_REPORT;
